"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeaderTitle = void 0;
const tslib_1 = require("tslib");
const components_1 = require("@bluebase/components");
const react_1 = tslib_1.__importDefault(require("react"));
const HeaderTitle = (_a) => {
    var { style, styles } = _a, rest = tslib_1.__rest(_a, ["style", "styles"]);
    return (react_1.default.createElement(components_1.Text, Object.assign({ testID: "header-title", numberOfLines: 1 }, rest, { style: [styles && styles.root, style] })));
};
exports.HeaderTitle = HeaderTitle;
HeaderTitle.defaultStyles = (theme) => ({
    root: Object.assign({}, theme.typography.h6),
});
